<div *ngIf="recordProperty != null" (click)="mouseEnter()"
  [ngClass]="moduleStructure !== undefined && moduleStructure.module.TableName + '-' + section.XmlTagName+'-' + field.FieldName + ' ' + recordProperty.CssClass ">
  <nz-form-item nz-tooltip [nzTooltipTitle]="
      field.AdditionalInformationParsed.LabelVisible || field.DataType == 20
        ? ''
        : (field.Label | locale)
    " [ngStyle]="{
      display:
        field.DataType == 11 ||
        field.AdditionalInformationParsed?.Visible === false ||
        recordProperty?.Visible === false
          ? 'none'
          : ''
    }">
    <nz-form-label [nzSpan]="labelWidth || 6" [class]="field.AdditionalInformationParsed.LabelClass" [nzNoColon]="true"
      [nzRequired]="recordProperty?.Required || false" [nzFor]="field.FieldName" style="white-space: pre-wrap" *ngIf="
        (section.Type !== 2 || forceLabelVisible) &&
        field.AdditionalInformationParsed.LabelVisible &&
        !field.AdditionalInformationParsed.LabelOnRight
      ">
      <span [innerHTML]="field.Label | locale"> </span>
    </nz-form-label>
    <ng-container *ngIf="(!recordProperty?.EditMode && inTable)">
      <div class="editable-cell" [class.readonly-cell]="recordProperty?.ReadOnly === true"
        [attr.aria-readonly]="recordProperty?.ReadOnly === true ? 'true' : null" nz-tooltip
        [nzTooltipTitle]="recordProperty?.ValueAsObject">
        {{ recordProperty?.ValueAsObject | valueRenderer: recordProperty: field: recordLine: recordProperty?.Options?.length }}
      </div>
    </ng-container>
    <nz-col [ngStyle]="{ 'text-align': field.AdditionalInformationParsed.LabelOnRight ? 'right' : 'left' }"
      *ngIf="(recordProperty?.EditMode || !inTable || initialized)"
      [hidden]="!(recordProperty?.EditMode || !inTable)"
      [nzSpan]="field.AdditionalInformationParsed.LabelOnRight ? labelWidth :inputWidth">
      <ng-container [ngSwitch]="field.DataType">
        <app-input-string *ngSwitchCase="1" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-string-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-string>
        <app-input-number *ngSwitchCase="2" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [parentClass]="parentClass + '-number-' + field.FieldName"
          [recordLine]="recordLine" [recordProperty]="recordProperty">
        </app-input-number>
        <app-input-select *ngSwitchCase="3" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-select-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-select>
        <app-input-link *ngSwitchCase="4" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-link-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-link>
        <app-input-date *ngSwitchCase="5" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-date-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-date>
        <app-input-time *ngSwitchCase="6" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-time-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-time>
        <app-input-text *ngSwitchCase="7" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-text-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-text>
        <app-input-price *ngSwitchCase="8" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-price-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-price>
        <app-input-percent *ngSwitchCase="9" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-percent-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-percent>
        <app-input-attachment *ngSwitchCase="10" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-attachment-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-attachment>
        <app-input-string *ngSwitchCase="11" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [recordProperty]="recordProperty">
        </app-input-string>
        <app-input-label *ngSwitchCase="12" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-label-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-label>
        <app-input-check *ngSwitchCase="18" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-check-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-check>
        <app-input-html *ngSwitchCase="20" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-html-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-html>
        <app-input-cc-validity *ngSwitchCase="21" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-cc-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-cc-validity>
        <app-input-amount *ngSwitchCase="23" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-amount-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-amount>
        <app-input-image *ngSwitchCase="25" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-image-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-image>
        <app-input-quantity *ngSwitchCase="26" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [scanControl]="scanControl" [recordCategory]="recordCategory"
          [parentClass]="parentClass + '-qty-' + field.FieldName" [recordLine]="recordLine"
          [recordProperty]="recordProperty">
        </app-input-quantity>
        <app-input-map *ngSwitchCase="31" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-map-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-map>
        <app-input-integer *ngSwitchCase="33" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-integer-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-integer>
        <app-input-number *ngSwitchCase="34" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [parentClass]="parentClass + '-number-' + field.FieldName"
          [recordLine]="recordLine" [recordProperty]="recordProperty">
        </app-input-number>
        <app-input-rate *ngSwitchCase="35" nz-col [recordModel]="recordModel" [field]="field" [section]="section"
          [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [recordLine]="recordLine"
          [parentClass]="parentClass + '-rate-' + field.FieldName" [recordProperty]="recordProperty">
        </app-input-rate>
        <app-input-price-lines *ngSwitchCase="FieldDataType.PriceLines" nz-col [recordModel]="recordModel" [field]="field"
          [section]="section" [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [parentClass]="parentClass + '-price-lines-' + field.FieldName"
          [recordLine]="recordLine" [recordProperty]="recordProperty">
        </app-input-price-lines>
        <app-input-price-from-document *ngSwitchCase="FieldDataType.PriceFromDocument" nz-col [recordModel]="recordModel"
          [field]="field" [section]="section" [sectionTagName]="section.XmlTagName" [lineId]="lineId"
          [moduleStructure]="moduleStructure" [actionType]="actionType" [parentClass]="parentClass + '-price-from-document-' + field.FieldName"
          [recordCategory]="recordCategory" [recordLine]="recordLine" [recordProperty]="recordProperty">
        </app-input-price-from-document>
        <app-input-address *ngSwitchCase="FieldDataType.Address" nz-col [recordModel]="recordModel" [field]="field"
          [section]="section" [sectionTagName]="section.XmlTagName" [lineId]="lineId" [moduleStructure]="moduleStructure"
          [actionType]="actionType" [recordCategory]="recordCategory" [parentClass]="parentClass + '-address-' + field.FieldName"
          [recordLine]="recordLine" [recordProperty]="recordProperty">
        </app-input-address>
      </ng-container>
    </nz-col>
    <nz-form-label [nzSpan]="inputWidth" [class]="field.AdditionalInformationParsed.LabelClass" [nzNoColon]="true"
      [nzRequired]="recordProperty?.Required" [nzFor]="field.FieldName"
      style="white-space: pre-wrap;text-align: left;padding-left: 10px;" *ngIf="
        (section.Type !== 2 || forceLabelVisible) &&
        field.AdditionalInformationParsed.LabelVisible &&
        field.AdditionalInformationParsed.LabelOnRight
      ">
      <span [innerHTML]="field.Label | locale"> </span>
    </nz-form-label>
  </nz-form-item>
</div>
